import React, { useEffect, useRef, useState } from "react";
//import "./styles/addCredit.scss";
import "../TicketManagement/style.scss";
import "../NewMember/RoleManagmentAndPermission/style.scss";
import {  getVendorFundRequestApproval, getVendorFundRequestList } from "../../utils/api";
import Pagination from "../../Components/Pagination/Pagination";
import Swal from "sweetalert2";
import LocalLoader from "../../Components/Loader/LocalLoader";
import { FilterWrapper } from "../../assets/styles/FilterStyle";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";
import companylogo from "../../assets/images/companylogo.png";
import { AlertWrapper } from "../../assets/styles/AlerWrapper";
import DatePicker from "react-datepicker";
import { getDateFromDateObj, isEmpty, isNumber } from "../../utils/common";
import { TableWrapper } from "../../Components/styledConstant";
import { ModalPopUp } from "../../Components/ModalPopUp/ModalPopUp";
import modalpopup from "../../assets/images/modalPopubg.svg";
import animationData1 from "../../assets/lotties/question.json";
import animationData2 from "../../assets/lotties/done_msg.json";
import Lottie from "react-lottie";
require("react-datepicker/dist/react-datepicker.css");

const  ManageFundRequest = ({ permission }) => {
  var currentDate = new Date();
  var formattedDate = [
    currentDate.getDate(),
    currentDate.getMonth() + 1,
    currentDate.getFullYear(),
  ]
    .map((n) => (n < 10 ? `0${n}` : `${n}`))
    .join("-");

  const [fundReqList, setFundReqList] = useState([]);
  const [totalPages, setTotalPages] = useState("");
  const [utr, setUtr] = useState("");
  const [currPage, setCurrPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [selectStatus, setSelectStatus] = useState("");
  const [transactionMode, setTransactionMode] = useState("");
  const [loading, setLoading] = useState(false);
  const [totalElements, setTotalElement] = useState("");
  const [pdfData, setPdfData] = useState([]);
  const [txnType, setTxnType] = useState("");
  const [fromDate, setStartDate] = useState("");
  const [toDate, setEndDate] = useState("");
  const [downloadLoader, setDownloadLoader] = useState("");
  const [updatedUserStatus, setUpdatedUserStatus] = useState({});
  const [userStatus, setUserStatus] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [showfilter, setShowFilter] = useState("");
  

  const navigate = useNavigate();
  const link = useRef();
  const location = useLocation();
  const userData = location.state;
  const [msg, setMsg] = useState(userData);

  const defaultOptions1 = {
    loop: true,
    autoplay: true,
    animationData: animationData1,
  };
  const defaultOptions2 = {
    loop: true,
    autoplay: true,
    animationData: animationData2,
  };

  let _fromDate = "";
  let _toDate = "";

  if (fromDate !== "" && toDate !== "") {
    _fromDate = getDateFromDateObj(fromDate, "YYYY-MM-DD");
    _toDate = getDateFromDateObj(toDate, "YYYY-MM-DD");
  }


  useEffect(() => {
    getList();
  }, [selectStatus,  txnType, transactionMode]);

  const handleApprove = (id, status) => {
    let msg = "";
    if (status == "APPROVED") {
      setUserStatus({
        msg: "You want to approve?",
        type: "APPROVE",
        place: "APPROVED",
      });
    } else {
      setUserStatus({ msg: "You want to Reject?", type: "REASON" });
    }

    setUpdatedUserStatus({ id, status });
  };

  const updateUserData = (userStatusUpdate) => {
    const params = {
      txnId:userStatusUpdate?.id,
      status:userStatusUpdate?.status
    }
    getVendorFundRequestApproval(params).then((resp) => {
        if ((resp?.data?.code === "0000") && userStatusUpdate?.status == "APPROVED") {
          getList();
          setShowMessage({
            errormsg: "Approved Successfully",
            type: "SUCCESS",
          });
        } else if (
          (resp?.data?.code === "0000") &&
          userStatusUpdate?.status == "REJECTED"
        ) {
          getList();
          setShowMessage({ errormsg: "Reject Successfully", type: "REJECTED" });
        } else {
          let errormsg = "";
          if (resp?.data?.errorCodeList?.length > 0) {
            errormsg = resp?.data?.errorCodeList[0];
          } else {
            if(resp?.data?.msg){
              errormsg = resp?.data?.msg;
            }else{
              errormsg = resp?.data?.message
            } 
          
          }
          setShowMessage({ errormsg: errormsg, type: "errorbutton" });
        }
      }
    );
  };

  const statusRefessh = () => {
    updateUserData(updatedUserStatus);
    setUserStatus({});
  };

  const refrshSttausData = () => {
    setShowMessage(false);
    setUserStatus({});
  
  };

  useEffect(() => {
    if (msg !== "") {
      setTimeout(() => {
        setMsg("");
      }, 5000);
    }
  }, [msg]);

  const getList = (key="",page="") =>{

    const params = {
      utrNo: utr,
      pagination:{
          pageNo:currPage,
          pageSize:pageSize
      }
    }

    if(key === "refresh"){
      params.utrNo = "";
      params.pagination.pageNo = 0;
    }

    if(key==="pagination"){
      params.pagination.pageNo = page;
   
    }
  
    if(key==="search"){
      params.pagination.pageNo = 0;
   
    }

    if((key === "pdf") || (key === "csv")){
      params.pagination.pageNo = 0;
      params.pagination.pageSize = totalElements;
      if(key === "csv"){
        setDownloadLoader("csv")
      }else{
        setDownloadLoader("pdf")
      }
    }else{
      setLoading(true);
    }
    getVendorFundRequestList(params).then((response) =>{
      setLoading(false);
      setDownloadLoader("")
      if (response?.data?.success) {
   if((key === "pdf")){
    pdfDownload(response?.data?.data?.content);
   }else if((key === "csv")){
    setPdfData(response?.data?.data?.content);

    setTimeout(() => {
      const csvlink = link.current;
      csvlink.link.click();
    }, 100);
   }else{
    setFundReqList(response?.data?.data?.content);
    setTotalPages(response?.data?.data?.totalPages)
    setTotalElement(response?.data?.data?.totalElements);
   }
     
      } else {
        let msg = "";
        if (response?.data?.errorCodeList.length > 0) {
          msg = response?.data?.errorCodeList[0];
        } else {
          msg = response?.data?.msg;
        }
       // setMessage({ msg: msg, type: "error" });
      }
    })
  }

  
  const pdfDownload = (data = []) => {
    let _width = 400; // Width of the custom size
    const height = 297;

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm", // units: mm, cm, in, px
      format: [_width, height],
      compress: true,
      putOnlyUsedFonts: true,
      precision: 16, // n
    });
    //Add image in PDF header
    const imgWidth = 25; // Adjust the width of the logo
    const imgHeight = 9; // Adjust the height of the logo
    const leftXPos = 14; // Adjust the X position
    const yPos = 2; // Adjust the Y position
    doc.addImage(companylogo, "PNG", leftXPos, yPos, imgWidth, imgHeight);

    //Add fileName in the center
    const text = "Vendor fund  Request";
    // Calculate the width of the text
    const textWidth =
      (doc.getStringUnitWidth(text) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;
    // Get the width of the PDF
    const pdfWidth = doc.internal.pageSize.width;
    const yPos1 = 10;
    // Calculate the X position for center alignment
    const centerXPos = (pdfWidth - textWidth) / 2;
    doc.text(text, centerXPos, yPos1);

    // Calculate the width of the date text
    const dateWidth =
      (doc.getStringUnitWidth(formattedDate) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;

    // Calculate the X position for right alignment
    const rightXPos = pdfWidth - dateWidth - 15; // 10 is for some margin from the right edge
    doc.text(formattedDate, rightXPos, yPos1);

    // Create a table from API data
    const tableData = [];
    //
    data.forEach((item, index) => {
      const rowData = [
        index + 1,
        item.merchantName,
        item.phoneNumber,
        item.bankName,
        item.accountNo,
        item.utr,
        item.transactionType,
        item.createdDate,
        item.amount,
        item.status,
      ]; // Customize as needed
      tableData.push(rowData);
    });

    doc.autoTable({
      head: [
        [
          "S.No",
          "Merchant Name",
          "Mobile Number",
          "Bank Name",
          "Account Number",
          "UTR No",
          "Transaction Type",
          "Created Date",
          "Amount",
          "Status",
        ],
  
                
      ], // Customize table header
      body: tableData,
    });

    doc.save("VendorFundRequest.pdf");
  };

const changePage = (page) =>{
  getList("pagination",page);
  setCurrPage(page)

}

const refresh = () =>{
  getList("refresh");
  setCurrPage(0);
  setUtr("")
}

const search = () =>{
  getList("search");
setCurrPage(0)

}
  return (
    <>
      <div>
        {msg && (
          <AlertWrapper className="success globle">
            <span className="close" onClick={() => setMsg("")}>
              ×
            </span>
            {msg}
          </AlertWrapper>
        )}
        <div className="" style={{ padding: "30px" }}>
          <div className="userlist_head">
            <div className="userlist_heading">
              <div className="userlist_left">
                <label>Manage Vendor Fund Request</label>
              </div>
              <div className="userlist_right">
                {downloadLoader !== "pdf" ? (
                  <button
                    className="pdf"
                    onClick={(e) => getList("pdf")}
                  >
                    PDF
                  </button>
                ) : (
                  <button className="pdf">
                    <div className="btn-loader">
                      <i className="fa-solid fa-spinner"></i>
                    </div>
                  </button>
                )}

                {downloadLoader !== "csv" ? (
                  <button
                    className="xls"
                    onClick={(e) => getList("csv")}
                  >
                    CSV
                  </button>
                ) : (
                  <button className="xls">
                    <div className="btn-loader">
                      <i className="fa-solid fa-spinner"></i>
                    </div>
                  </button>
                )}
                <CSVLink
                  ref={link}
                  data={pdfData}
                  filename="vendor-fund-request.csv"
                ></CSVLink>
              </div>
              <div className="userlist_filter">
                <button
                  className="filter fs-16"
                  onClick={(e) =>
                    showfilter === "active"
                      ? setShowFilter("")
                      : setShowFilter("active")
                  }
                >
                  <i className="fa-solid fa-filter"></i>
                </button>
              </div>
            </div>
          </div>
          <FilterWrapper
            style={{ height: "auto" }}
            className={`display_data ${showfilter}`}
          >
            <div className="filterBox">
            
                <div className="flex align-items gap-15">
                  <div>
                    <div className="input-field">
                    <input type="text"
                    value={utr}
                    placeholder="Enter utr No"
                    onChange={(e) =>setUtr(e.target.value)}
                     />
                    </div>
                  </div>
                  <div className=" flex gap-10">
                    <button className="userlist_btn" onClick={(e) => search()}>
                      Search
                    </button>
                    <button className="userlist_btn" onClick={refresh}>
                    <i className="fa fa-refresh" aria-hidden="true"></i> Refresh
                    </button>
                  </div>

                  {/* <div className="input-field">
                    <div className="flex">
                      <DatePicker
                        showIcon
                        className="date-picker2 date_type"
                        placeholderText="From Date"
                        selected={fromDate}
                        selectsStart
                        startDate={fromDate}
                        endDate={toDate}
                        yearDropdownItemNumber={100}
                        scrollableYearDropdown={true}
                        showYearDropdown
                        onKeyDown={(e) => e.preventDefault()}
                        onChange={(date) => setStartDate(date)}
                        maxDate={new Date()}
                      />
                    </div>
                  </div>
                  <div className="input-field">
                    <div className="flex">
                      <DatePicker
                        showIcon
                        className="date-picker2 date_type"
                        placeholderText="To Date"
                        selected={toDate}
                        selectsEnd
                        startDate={fromDate}
                        endDate={toDate}
                        minDate={fromDate}
                        yearDropdownItemNumber={100}
                        scrollableYearDropdown={true}
                        showYearDropdown
                        onKeyDown={(e) => e.preventDefault()}
                        onChange={(date) => setEndDate(date)}
                        maxDate={new Date()}
                      />
                    </div>
                  </div> */}
                 
                </div>
       
            </div>
          </FilterWrapper>

          {fundReqList && (
            <div className="table-loader">
              {loading && <LocalLoader className="tableLoader" />}
              <TableWrapper className="table-card-wrapper">
                <table className="table">
                  <thead>
                    <tr>
                      <th>S.No.</th>
                  <th>Merchant Name</th>
                  <th>Mobile Number</th>
                   <th>Bank Name</th>
                  <th>Account Number</th>
                  <th>UTR No</th>
                  <th>Transaction Type</th>
                  <th>Created Date</th>
                  <th>Amount</th>
                  <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fundReqList &&
                      fundReqList?.map((item, index) => {
                        // const [date, time] = item.createdDate.split("T");
                        // let newTime = time.slice(0, 8);

                        // const [modifyDate, modifyTime] =
                        //   item.lastModifiedDate.split("T");
                        // let newModifyTime = modifyTime.slice(0, 8);
                        return (
                          <tr key={index}>
                            <td>
                              <span className="card-th">Sr. N0.</span>
                              <span className="card-td">{(currPage*pageSize)+index + 1}</span>
                            </td>
                            <td>
                              <span className="card-th">Merchant Name</span>
                              <span className="card-td">{item.merchantName}</span>
                            </td>
                            <td>
                              <span className="card-th">Mobile Number</span>
                              <span className="card-td">{item.phoneNumber}</span>
                            </td>
                            <td>
                              <span className="card-th">Bank Name</span>
                              <span className="card-td">{item.bankName}</span>
                            </td>
                            {/* <td>{bank.branchName}</td> */}
                            
                            <td>
                              <span className="card-th">Account Number</span>
                              <span className="card-td">{item.accountNo}</span>
                            </td>
                            <td>
                              <span className="card-th">UTR No</span>
                              <span className="card-td">{item.utr}</span>
                            </td>
                            <td>
                              <span className="card-th">Transaction Type</span>
                              <span className="card-td">{item.transactionType}</span>
                            </td>
                            <td>
                              <span className="card-th">Created Date</span>
                              <span className="card-td">{item.createdDate}</span>
                            </td>
                            <td>
                              <span className="card-th">Amount</span>
                              <span className="card-td">₹ {item.amount}</span>
                            </td>
                        
                            <td>
                            <span className="card-th">Status</span>
                               <span
                                className={`${
                                  item?.status === "APPROVED"
                                    ? "active_status"
                                    : "inactive_status"
                                }`}
                              >
                                {" "}
                                {item?.status}
                              </span>
                            </td>
                            
                            {item.status === "PENDING" && (
                              <td>
                                <span className="card-th">Action</span>
                                <span>
                                  {item.status === "PENDING" && (
                                    <div className="flex">
                                      <button
                                        onClick={() =>
                                          handleApprove(
                                            item.txnId,
                                            "APPROVED"
                                          )
                                        }
                                        className="btn_action"
                                      >
                                        Approve
                                      </button>
                                      <button
                                        onClick={() =>
                                          handleApprove(
                                            item.txnId,
                                            "REJECTED"
                                          )
                                        }
                                        className="btn_action"
                                        style={{ marginLeft: "7px" }}
                                      >
                                        Reject
                                      </button>
                                    </div>
                                  )}
                                </span>
                              </td>
                            )}
                            

                          </tr>
                        );

                      })}

                    {!loading &&
                      fundReqList &&
                      fundReqList.length < 1 && (
                        <tr>
                          <td
                            colSpan={6}
                            style={{ textAlign: "center", color: "red" }}
                          >
                            No data found
                          </td>
                        </tr>
                      )}
                  </tbody>
                </table>
              </TableWrapper>
            </div>
          )}
        </div>
        <div style={loading ? { opacity: "0" } : { opacity: "1" }}>
          {totalPages > 1 && (
            <Pagination
              items={fundReqList}
              itemsPerPage={pageSize}
              setitemsPerPage={setPageSize}
              currentPage={currPage}
              setcurrentPage={changePage}
              totalPages={totalPages}
            />
          )}
        </div>

        {!isEmpty(userStatus) && (
          <ModalPopUp>
            <div
              className="modal-popup"
              style={{
                backgroundImage: `url(${modalpopup})`,
                backgroundRepeat: "no-repeat",
                backgroundPositionX: "right",
                backgroundPositionY: "bottom",
                // height: "270px",
              }}
            >
              <div className="mt-20">
                <Lottie
                  options={defaultOptions1}
                  height={80}
                  width={80}
                ></Lottie>
              </div>

              {userStatus.type === "REASON" && (
                <>
                  <div className="flex justify-center">
                    <label className="fs-18 fw-600">{userStatus.msg}</label>
                  </div>
                  {/* <div className="flex justify-center">
                    <input
                      type="text"
                      placeholder="please enter reject reason"
                      style={{ width: "330px", backgroundColor: "#f0f0f0" }}
                    />
                  </div> */}
                </>
              )}

              {userStatus.type === "APPROVE" && (
                <>
                  <div className="flex justify-center ">
                    <label className="fs25 blue_font fw-bold">
                      Are you sure!
                    </label>
                  </div>
                  <div className="flex justify-center">
                    <label>{userStatus.msg}</label>
                  </div>
                </>
              )}
              <div className="flex justify-center gap-10 mt-30">
                <button
                  onClick={() => setUserStatus({})}
                  className="cancel_button"
                >
                  No, Cancel it
                </button>
                <button
                  // onClick={() => setUpdatedUserStatus(true)}
                  onClick={() => statusRefessh()}
                  className="confirm_button"
                >
                  Yes, I am sure!
                </button>
              </div>
            </div>
          </ModalPopUp>
        )}
        {showMessage && (
          <ModalPopUp>
            <div
              className={
                `${showMessage.type} && ${showMessage.type === "errorbutton"}`
                  ? "error-popup"
                  : "modal-popup"
              }
              style={{
                backgroundImage: `url(${modalpopup})`,
                backgroundRepeat: "no-repeat",
                backgroundPositionX: "right",
                backgroundPositionY: "bottom",
                // height:"270px"
              }}
            >
              <>
                {showMessage.type === "SUCCESS" && (
                  <>
                    <div>
                      <Lottie
                        options={defaultOptions2}
                        height={80}
                        width={80}
                      ></Lottie>
                    </div>

                    <div className="flex justify-center ">
                      <label className="fs25 blue_font fw-bold">Done!</label>
                    </div>
                  </>
                )}
                <div
                  className={`flex justify-center ${
                    showMessage.type === "errorbutton" ? "mt-30" : ""
                  }`}
                >
                  <label>{showMessage.errormsg}</label>
                </div>
                <div className="flex justify-center gap-10 mt-16">
                  {showMessage.type === "SUCCESS" && (
                    <button
                      className="confirm_button"
                      onClick={() => refrshSttausData()}
                    >
                      Close
                    </button>
                  )}

                  {(showMessage.type === "errorbutton" ||
                    showMessage.type === "REJECTED") && (
                    <button
                      className="error_button "
                      onClick={() => refrshSttausData("")}
                    >
                      OK
                    </button>
                  )}
                </div>
              </>
            </div>
          </ModalPopUp>
        )}
      </div>
    </>
  );
};
export default ManageFundRequest;
